exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group-sm > .btn, .btn-sm {\r\n  padding: .30rem .3rem;\r\n  font-size: .675rem;\r\n  /* border-radius: .2rem; */\r\n  border-color: grey;\r\n  color: #ffffff;\r\n  box-shadow: none;\r\n  height: 1.5rem;\r\n}\r\n\r\n.btn-outline-primary.active, .btn-outline-primary:active, .show > .btn-outline-primary.dropdown-toggle {\r\n  color: #ffffff;\r\n  background-color: grey;\r\n  border-color: grey;\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n  color: #ffffff;\r\n  background-color: grey;\r\n  border-color: grey;\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-group, .btn-group-vertical {\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-outline-primary:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n/* .btn-group-vertical>.btn, .btn-group>.btn {\r\n  margin-top: 8px;\r\n} */\r\n\r\n.language-switcher {\r\n  display: inline-block;\r\n}\r\n\r\n@media (max-width: 440px) {\r\n  .language-switcher {\r\n    display: none;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/header/language-switcher/language-switcher/language-switcher.component.css
// module id = ../../../../../src/app/header/language-switcher/language-switcher/language-switcher.component.css
// module chunks = main